import { mapAmenityPreviews } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function MapAmenitiesBridge() {
  return (
    <section aria-labelledby="map-amenities-heading" className="bg-secondary/35 py-14 md:py-18">
      <div className="shell">
        <Reveal>
          <Eyebrow>More Around the Resort</Eyebrow>
        </Reveal>
        <h2 id="map-amenities-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>Everything You Need</MaskReveal>
          <MaskReveal delay={0.08}>Between Adventures</MaskReveal>
        </h2>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {mapAmenityPreviews.map((item, i) => (
            <li key={item.label} className={i === 6 ? "lg:col-span-1 sm:col-span-2 lg:col-start-2" : ""}>
              <Reveal delay={Math.min(i, 5) * 0.04}>
                <article className="group overflow-hidden border border-border bg-card">
                  <p className="p-4 text-sm font-medium tracking-tight">{item.label}</p>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>

        <Reveal delay={0.1}>
          <ResortLink variant="solid" href="/amenities/" className="mt-10 w-full sm:w-auto">
            Explore Amenities
          </ResortLink>
        </Reveal>
      </div>
    </section>
  );
}
